/**
 * Logo list — mobile 2×2 page autoplay for grid layout.
 */
(function () {
  'use strict';

  function initAutoplay(carousel) {
    const speed = parseInt(carousel.dataset.autoplay || '0', 10);
    if (!speed || speed <= 0) return;

    let timer = null;
    let resumeTimer = null;

    const tick = () => {
      if (!carousel.cells || carousel.cells.length <= 1) return;

      const idx = typeof carousel.selectedIndex === 'number' ? carousel.selectedIndex : 0;
      const lastIdx = carousel.cells.length - 1;

      if (idx >= lastIdx) {
        carousel.select(0);
      } else {
        carousel.next();
      }
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = null;
    };

    const start = () => {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!carousel.classList.contains('is-scrollable')) return;
      timer = window.setInterval(tick, speed * 1000);
    };

    const pauseAndResume = () => {
      stop();
      resumeTimer = window.setTimeout(start, 4000);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) start();
        else stop();
      },
      { threshold: 0.2 }
    );
    observer.observe(carousel);

    carousel.addEventListener('pointerdown', stop, { passive: true });
    carousel.addEventListener('pointerup', pauseAndResume, { passive: true });
    carousel.addEventListener('touchstart', stop, { passive: true });
    carousel.addEventListener('touchend', pauseAndResume, { passive: true });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });

    carousel._logoListAutoplayCleanup = () => {
      stop();
      observer.disconnect();
    };
  }

  function init(root) {
    (root || document)
      .querySelectorAll('scroll-carousel.logo-list--mobile-pages[data-autoplay]:not([data-autoplay-bound])')
      .forEach((carousel) => {
        carousel.dataset.autoplayBound = '1';
        customElements.whenDefined('scroll-carousel').then(() => {
          requestAnimationFrame(() => initAutoplay(carousel));
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
